import gsap from 'gsap';
import { SECTIONS_IDS } from 'constants/global';

export const stagesAnimation = cardsContainerRef => () => {
  const mm = gsap.matchMedia();

  mm.add(
    {
      notMobile: '(min-width: 740px)',
      isMobile: '(max-width: 739px)',
    },
    context => {
      const { notMobile } = context.conditions;
      if (!notMobile) return;

      const line = document.getElementById('stages-route-line');
      if (!line) return;

      // @ts-ignore
      const length = line.getTotalLength();
      gsap.set(line, { strokeDasharray: length, strokeDashoffset: length });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: `#${SECTIONS_IDS.stages}`,
          start: '-=25 top',
          end: '+=2000',
          scrub: true,
          pin: true,
          pinSpacing: 'padding',
          invalidateOnRefresh: true,
        },
      });

      tl.to(line, { strokeDashoffset: 0, duration: 1, ease: 'none' });

      const checkpoints = [
        { id: 'checkpoint-2', progress: 0.18 },
        { id: 'checkpoint-3', progress: 0.35 },
        { id: 'checkpoint-4', progress: 0.5 },
        { id: 'checkpoint-5', progress: 0.67 },
        { id: 'checkpoint-6', progress: 0.82 },
        { id: 'checkpoint-7', progress: 0.96 },
      ];

      checkpoints.forEach(({ id, progress }, i) => {
        const g = document.getElementById(id);
        if (!g) return;
        const [bg, border] = g.querySelectorAll('rect');
        const text = g.querySelector('path');

        const CARDS_GAP = 16;
        const getSlideWidth = () =>
          (cardsContainerRef.current?.parentElement?.offsetWidth ?? 0) + CARDS_GAP;

        const activateDot = () => {
          gsap.set(bg, { attr: { fill: '#00BE85' } });
          gsap.set(border, { attr: { stroke: '#00BE85' } });
          gsap.set(text, { attr: { fill: '#151D28' } });
          gsap.to(cardsContainerRef.current, {
            x: -(i + 1) * getSlideWidth(),
            duration: 0.35,
            ease: 'power2.out',
          });
        };
        const deactivateDot = () => {
          gsap.set(bg, { attr: { fill: '#151D28' } });
          gsap.set(border, { attr: { stroke: '#293848' } });
          gsap.set(text, { attr: { fill: '#FFFAEA' } });
          gsap.to(cardsContainerRef.current, {
            x: -i * getSlideWidth(),
            duration: 0.35,
            ease: 'power2.out',
          });
        };

        tl.to(
          {},
          { duration: 0.001, onStart: activateDot, onReverseComplete: deactivateDot },
          progress,
        );
      });
    },
  );
};
